import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { StreamingService } from 'src/app/services/streaming.service'
import { DomSanitizer } from '@angular/platform-browser';
import Swal from 'sweetalert2';
import { UserHelper } from '../../helpers/user';
import { environment } from '../../../environments/environment';
import { CommonHelper } from 'src/app/helpers/common';
declare var $: any;
declare var devtools:any;

@Component({
    selector: 'app-player',
    templateUrl: './player.component.html',
    styleUrls: ['./player.component.css']
})
export class PlayerComponent implements OnInit, OnDestroy {

    public hasVideo = false;
    public videoUrl: any = '';
    public isLive = false;
    public isOndemand = false;
    public urlNotFound = false;
    public isValidVideo = false;
    private testing = false;
    private mlbId = '';
    public hasScoreboard = false;
    public temperedPlayer = false;

    constructor(
        private auth: AuthService,
        private streaming: StreamingService,
        private userHelper: UserHelper,
        private route: ActivatedRoute,
        private commonHelper: CommonHelper,
        private domSanitizer: DomSanitizer) {
        if(typeof this.route.snapshot.data.testing !== 'undefined'){
            this.testing = this.route.snapshot.data.testing;
            this.mlbId = '1'; 
        } else {
            this.mlbId = this.route.snapshot.paramMap.get('mlb_id');
        }
        this.commonHelper.currentUrl = 'player';
    }
    ngOnDestroy(): void { 
        this.commonHelper.currentUrl = '';
    }
    ngOnInit(): void {
        const user = this.userHelper.getUser();
        // 1.- Validamos el token para verificar que tiene el paquete comprado
        if (user.hasOneValidMembership || this.testing) {
            // 2.- Validamos que venga el mlb_id para poder buscar en la api
            if (this.mlbId !== '' && this.mlbId != null) {
                // 3.- Buscamos en la api el juego por el mlb_id comenzando por fecha actual y despues en todos juegos
                this.streaming.getGameByMlbId(this.mlbId).subscribe((resp: any) => {
                    let game = resp.response;
                    if (game['status'] == 'Live' || game['status'] == 'On Demand' ) {
                        this.isLive = game['status'] == 'Live';
                        this.isOndemand = game['status'] == 'On Demand';
                        this.isValidVideo = true;
                        this.initStreaming(game['streaming']);
                        return;
                    }
                    this.urlNotFound = true;
                    console.log('No disponible juego ' + this.mlbId, game);

                }, err => {
                    let game = [];
                    this.urlNotFound = true;
                    console.log('No disponible juego ' + this.mlbId, game);
                });
            }
        } else {//redireccionamos a paquetes en caso de no tener membresias
            window.location.href = 'home#section-price';
        }
    }

    initStreaming(url) {
        //$('app-header').html("");
        //$('app-header').css("background-color", "rgb(41, 116, 176)");

        let errorMessage = 'Ha ocurrido un error';

        this.auth.video(url, this.mlbId).subscribe(async (resp: any) => {
            if(typeof resp.response !== 'undefined'){
                this.videoUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(`${environment.urlPlayer}?src=${resp.response.st}`);
                this.hasVideo = true;
            }
        }, (err) => {
            if (typeof err.status !== 'undefined') {
                if (err.status === 409) {
                    errorMessage = 'Ya se encuentra una sesión abierta con esta cuenta desde otro dispositivo, por favor cerrar sesión en el otro dispositivo y volver a intentarlo';
                } else if (err.status === 400) {
                    errorMessage = 'Ha ocurrido un error';
                }
                Swal.fire({
                    allowOutsideClick: false,
                    type: 'warning',
                    text: errorMessage,
                    confirmButtonText: 'OK'
                });
            }
        });
    }

}
